import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import swal from "sweetalert2";
import { AppService } from 'src/app/core/services/app.service';
import { LoadingBarService } from '@ngx-loading-bar/core';
import { ExcelService } from 'src/app/core/services/excel.service';
import { Title } from '@angular/platform-browser';
import { SwalService } from 'src/app/core/services/swal.service';
import { Router } from '@angular/router';
import { LocalStorageService } from 'ngx-webstorage';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { GlobalVariableService } from 'src/app/core/services/global-variable.service';
import { DatePipe } from '@angular/common';
import * as FileSaver from 'file-saver';
import { ToastrService } from 'ngx-toastr';
import {AppConfigService} from "../../../../../../core/services/config.service";

@Component({
  selector: 'app-formations-reporting',
  templateUrl: './formations.component.html',
  encapsulation: ViewEncapsulation.None,
  styles: [`
      .dark-modal .modal-content {
        background-color: #292b2c;
        color: white;
      }
      .dark-modal .close {
        color: white;
      }
      .light-blue-backdrop {
        background-color: #5cb3fd;
      }
  `]
})

export class FormationsComponent implements OnInit {

  public direction: any;
  public selectedDirection: any;
  public selectedStructure: any;
  public selectedEiaCampagneId: any;
  public settingsDirection = {};
  public settingsEiaCampagneId = {};
  public settingsStructure = {};
  public listDirection: any = [];
  public listStructure: any = [];
  public matricule: any;
  public listAgent: any;
  public nbre_agents: any;
  public vueListAgent = false;

  public key = 'nom';
  public reverse = false;
  public p = 1;
  public filter: string;
  public id_campagne: any;
  public code_campagne: any;
  public id_direction: any;
  public code_direction: any;
  public id_structure: any;
  public code_structure: any;
  public listCampagne: any;
  public response: any;
  public API_URL: any;
  public user: any;
  public ENVIRONNEMENT: any;
  public filename;

  constructor(
    private _service: AppService,
    private _loader: LoadingBarService,
    private toastrService: ToastrService,
    private _excelService: ExcelService,
    private _swal: SwalService,
    private _router: Router,
    private title: Title,
    private variable: GlobalVariableService,
    public configService: AppConfigService,
    public datepipe: DatePipe,
    private http: HttpClient,
  ) {
    this.API_URL = configService.get('HOST_API_ONLINE');
    this.ENVIRONNEMENT = configService.get('HOST_ENVIRONMENT');
  }

  ngOnInit() {
    this.getAllDirection();
    this.title.setTitle('Reporting EIA | HR Performance');
    this.settingsDirection = {
      singleSelection: true,
      text: 'Selectionner la direction',
      classes: 'myclass custom-class',
      labelKey: 'code',
      enableSearchFilter: true,
      searchBy: ['code'],
      searchPlaceholderText: 'Rechercher',
      noDataLabel: 'Aucune direction disponible'
    };

    this.settingsStructure = {
      singleSelection: true,
      text: 'Selectionner la structure',
      classes: 'myclass custom-class',
      labelKey: 'code',
      enableSearchFilter: true,
      searchBy: ['code'],
      searchPlaceholderText: 'Rechercher',
      noDataLabel: 'Aucune structure disponible'
    };

    this.settingsEiaCampagneId = {
      singleSelection: true,
      text: 'Selectionner la campagne',
      classes: 'myclass custom-class',
      labelKey: 'libelle',
      enableSearchFilter: true,
      searchBy: ['libelle'],
      searchPlaceholderText: 'Rechercher',
      noDataLabel: 'Aucune campagne disponible'
    };
    // Get All Campagne
    this._service.postData('gestion-campagnes/eia/all-campagnes-active', {}).subscribe(data => {
      if (data.error === false) {
        this.listCampagne = data.data;
      } else {
        console.log(data.message);
      }
    });
  }

  ouvrirFiche(data, type_fiche, type_sauvegarde, category) {
    // tslint:disable-next-line: max-line-length
    this._router.navigateByUrl(`campagne/reporting-eia/agent/${data?.id}/${data?.agent_id}/type_fiche/${type_fiche}/type_sauvegarde/${type_sauvegarde}/${category}/statut/approuvé`);
  }

  getAllDirection() {
    this._loader.start();
    this._service.getData('capital-humain/structures/direction')
      .subscribe(
        res => {
          if (res.error === false) {
            this._loader.stop();
            this.listDirection = res.data;
          } else {
            this._loader.stop();
            this._swal.error(res.message);
          }
        }, err => {
          this._loader.stop();
          this.toastrService.error(err.error.message);
        }
      );
  }

  // Get all structure
  getAllStructure(idDirection) {
    this._loader.start();
    this._service.getData('capital-humain/structures/' + idDirection + '/structure-of-direction').subscribe((data: {}) => {
      this._loader.stop();
      this.response = data;
      this.listStructure = this.response.data;
    });
  }

  onSelectDirection(item) {
    this.id_direction = item.id;
    this.code_direction = item.code;
    this.getAllStructure(item.id);
  }

  onSelectStructure(item) {
    this.id_structure = item.id;
    this.code_structure = item.code;
  }

  onSelectEiaCampagneId(item) {
    this.id_campagne = item.id;
    this.code_campagne = item.code;
  }

  onDeSelectItem(item, type) {
    if (type === 'direction') {
      this.id_direction = '';
      this.code_direction = '';
      this.id_structure = '';
      this.code_structure = '';
    } else if (type === 'structure') {
      this.id_structure = '';
      this.code_structure = '';
    } else if (type === 'id_campagne') {
      this.id_campagne = '';
      this.code_campagne = '';
    } else {
      return;
    }
  }

  exportXls() {
    this._loader.start();
    const arrayAgent = [];
    for (let i = 0; i < this.listAgent.length; i++) {
      arrayAgent.push(
        {
          'Matricule': this.listAgent[i].matricule,
          'Nom & Prénoms': this.listAgent[i].nom + ' ' + this.listAgent[i].prenoms,
          'Direction': this.listAgent[i].direction,
          'Service': this.listAgent[i].service,
          'Section': this.listAgent[i].section,
          'Sous-Section': this.listAgent[i].sous_section,
          'Tenue de poste': this.listAgent[i].resultat_synthese_competence,
          'Performance': this.listAgent[i].resultat_synthese_performance,
          'Resultat global': this.listAgent[i].resultat_global,
          'Appréciation global': this.listAgent[i].appreciation_global
        }
      );
    }
    this._excelService.exportAsExcelFile(arrayAgent, 'reporting_recherche_agent');
    this._loader.stop();
  }

  rechercher() {
    this._loader.start();
    const obj = {
      campagne_id: this.id_campagne,
      code_direction: this.code_direction,
      code_structure: this.code_structure,
      matricule: this.matricule,
    };
    this._service.postData('reporting/get_formation_reporting', obj).subscribe(
      (res) => {
        if (res.error === false) {
          this._loader.stop();
          this.listAgent = res.data;
          this.nbre_agents = this.listAgent.length;
          if (this.listAgent.length <= 0) {
            swal.fire({
              title: 'HR PERF',
              type: 'warning',
              text: 'Aucune donnée disponible',
              showCancelButton: false,
              confirmButtonText: 'ok',
            });
          } else {
            this.vueListAgent = true;
          }
        } else {
          swal.fire({
            title: 'HR PERF',
            type: 'warning',
            text: res.message,
            showCancelButton: false,
            confirmButtonText: 'ok',
          });
          this._loader.stop();
          this.vueListAgent = false;
        }
      },
      (err) => {
        this.toastrService.error(err.error.message);
        this._loader.stop();
        this.vueListAgent = false;
      }
    );
  }

  exportAgentFormations() {
    const header = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Access-Control-Allow-Headers': 'Content-Type',
      Authorization: 'Bearer ' + this.variable.getAccessToken(),
    }

    const requestOptions = {
      headers: new Headers(header),
    };
    this._loader.start();
    let today = new Date();
    let date = this.datepipe.transform(today, 'yyyy-MM-dd')
    let agentFilter = this.listAgent.filter(element => element.matricule == this.matricule)
    console.log('agent filter is :', agentFilter)
    this.filename = "Liste_formation" + "_" + this.matricule + "_" + agentFilter.nom + "_" + agentFilter.prenoms;

    return fetch(this.API_URL + `reporting/${this.id_campagne}/${this.matricule}/export_formation`, requestOptions)
      .then(
        res => res.blob()
      )
      .then(blob => {
        FileSaver.saveAs(blob, this.filename);
        this._loader.stop();
      })
      .catch(err => {
        this._loader.stop();
        swal.fire({
          title: 'HR PERF',
          text: JSON.stringify(err),
          type: 'error',
          confirmButtonColor: '#FD7E14',
          confirmButtonText: 'Ok'
        });
      });
  }

  downloadFormationsByAgent(data) {
    const header = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Access-Control-Allow-Headers': 'Content-Type',
      Authorization: 'Bearer ' + this.variable.getAccessToken(),
    }

    const requestOptions = {
      headers: new Headers(header),
    };
    this._loader.start();
    let today = new Date();
    let date = this.datepipe.transform(today, 'yyyy-MM-dd')
    console.log('agent data is :', data)
    this.filename = "Liste_formation" + "_" + data.matricule + "_" + data.nom + "_" + data.prenoms;

    return fetch(this.API_URL + `reporting/${this.id_campagne}/${data.matricule}/export_formation`, requestOptions)
      .then(
        res => res.blob()
      )
      .then(blob => {
        FileSaver.saveAs(blob, this.filename);
        this._loader.stop();
      })
      .catch(err => {
        this._loader.stop();
        swal.fire({
          title: 'HR PERF',
          text: JSON.stringify(err),
          type: 'error',
          confirmButtonColor: '#FD7E14',
          confirmButtonText: 'Ok'
        });
      });
  }


}
